import * as constants from "./constants";
import { getLSKey, LS_KEYS } from "../../../utils/localStorageHelper";

const initialState = {
  statusOptions: [],
  allLabs: [],
  currentLabObj: {},
  utilsData: {},
  updateNotLoading: false,
  departmentsList: [],
  createLabLoading: false,
  labDetailsIsEdit: false,
  fetchLabsLoading: false,
  deleteLabLoading: false,
  fetchLabDetailLoading: false,
  totalRecords: 0,
  deleteAttachLoading: false,
  labNotificationIsEdit: false,
  deleteRecipientLoading: false,
  fetchLabUsersLoading: false,
  assignedUsers: [],
  labUsersMap: {},
  warehouses: [],
  fetchWarehousesLoading: false,
};

const labsSetupReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_LABS_UTIL_DATA_SUCCESS:
      // const { sales_reps } = action.data;
      return {
        ...state,
        utilsData: {
          ...action.data,
        },
      };
    case constants.LAB_DETAILS_IS_EDIT:
      return {
        ...state,
        labDetailsIsEdit: action.data,
      };

    case constants.CREATE_LAB:
      return {
        ...state,
        createLabLoading: true,
      };
    case constants.CREATE_LAB_SUCCESS:
      return {
        ...state,
        createLabLoading: false,
        currentLabObj: action.data,
        labDetailsIsEdit: false,
      };
    case constants.CREATE_LAB_ERROR:
      return {
        ...state,
        createLabLoading: false,
      };
    case constants.UPDATE_LAB:
      return {
        ...state,
        createLabLoading: true,
      };
    case constants.UPDATE_LAB_SUCCESS:
      return {
        ...state,
        createLabLoading: false,
        currentLabObj: action.data,
        labDetailsIsEdit: false,
      };
    case constants.UPDATE_LAB_ERROR:
      return {
        ...state,
        createLabLoading: false,
      };

    case constants.UPDATE_LAB_NOTIFICATION:
      return {
        ...state,
        updateNotLoading: true,
      };
    case constants.UPDATE_LAB_NOTIFICATION_SUCCESS:
      return {
        ...state,
        updateNotLoading: false,
        labNotificationIsEdit: false,
      };
    case constants.UPDATE_LAB_NOTIFICATION_ERROR:
      return {
        ...state,
        updateNotLoading: false,
      };

    case constants.FETCH_ALL_LABS:
      return {
        ...state,
        fetchLabsLoading: true,
      };
    case constants.FETCH_ALL_LABS_SUCCESS:
      const responseData = action.data;
      const data = responseData?.data || [];
      const total = responseData?.meta?.total || responseData?.total || data.length;
      return {
        ...state,
        allLabs: data,
        fetchLabsLoading: false,
        totalRecords: total,
      };
    case constants.FETCH_ALL_LABS_ERROR:
      return {
        ...state,
        fetchLabsLoading: false,
      };
    case constants.DELETE_LAB:
      return {
        ...state,
        deleteLabLoading: true,
      };
    case constants.DELETE_LAB_SUCCESS:
      let updatedLabs = state.allLabs.filter(
        (el) => el.id !== action.data.id
      );
      let totalRecords = state.totalRecords - 1;
      let lselectedLabs = JSON.parse(
        localStorage.getItem(getLSKey(LS_KEYS.SELECTED_LABS))
      );

      if (lselectedLabs?.length > 0) {
        let lisCheck = JSON.parse(localStorage.getItem(getLSKey(LS_KEYS.IS_CHECK)));
        let llist = JSON.parse(localStorage.getItem(getLSKey(LS_KEYS.LIST)));
        let lfilteredLabs = JSON.parse(
          localStorage.getItem(getLSKey(LS_KEYS.FILTERED_LABS))
        );
        let updatedlsselectedLabs = lselectedLabs.filter(
          (lab) => lab.id !== action.data.id
        );

        if (updatedlsselectedLabs.length > 0) {
          localStorage.setItem(
            getLSKey(LS_KEYS.SELECTED_LABS),
            JSON.stringify(updatedlsselectedLabs)
          );

          if (lselectedLabs !== null) {
            let userPojectsIds = updatedLabs.map((el) => el.id);

            let updatedLsfilteredLabs = lfilteredLabs.filter((el) =>
              userPojectsIds.includes(el.id)
            );

            let updatedlsisCheck = lisCheck.filter((id) =>
              userPojectsIds.includes(id)
            );
            let updatedlslist = llist.filter((el) =>
              userPojectsIds.includes(el.id)
            );

            localStorage.setItem(
              getLSKey(LS_KEYS.SELECTED_LABS),
              JSON.stringify(updatedlsselectedLabs)
            );
            localStorage.setItem(
              getLSKey(LS_KEYS.FILTERED_LABS),
              JSON.stringify(updatedLsfilteredLabs)
            );

            localStorage.setItem(getLSKey(LS_KEYS.IS_CHECK), JSON.stringify(updatedlsisCheck));
            localStorage.setItem(getLSKey(LS_KEYS.LIST), JSON.stringify(updatedlslist));
          }
        } else {
          localStorage.removeItem(getLSKey(LS_KEYS.SELECTED_LABS));
          localStorage.removeItem(getLSKey(LS_KEYS.FILTERED_LABS));
          localStorage.removeItem(getLSKey(LS_KEYS.IS_CHECK));
          localStorage.removeItem(getLSKey(LS_KEYS.LIST));
        }
      }

      return {
        ...state,
        totalRecords: totalRecords,
        deleteLabLoading: false,
        allLabs: updatedLabs,
      };
    case constants.DELETE_LAB_ERROR:
      return {
        ...state,
        deleteLabLoading: false,
      };

    case constants.DELETE_LAB_ATTACH:
      return {
        ...state,
        deleteAttachLoading: true,
      };
    case constants.DELETE_LAB_ATTACH_SUCCESS:
      const { id } = action.data;

      let updatedDocs = state.currentLabObj.documentUrls.filter(
        (el) => el.id != id
      );

      return {
        ...state,
        deleteAttachLoading: false,
        currentLabObj: {
          ...state.currentLabObj,
          documentUrls: updatedDocs,
        },
      };
    case constants.DELETE_LAB_ATTACH_ERROR:
      return {
        ...state,
        deleteAttachLoading: false,
      };

    case constants.FETCH_LAB:
      return {
        ...state,
        // departmentLoading: true,
        fetchLabDetailLoading: true,
      };
    case constants.FETCH_LAB_SUCCESS:
      return {
        ...state,
        currentLabObj: action.data,
        fetchLabDetailLoading: false,
      };
    case constants.FETCH_LAB_ERROR:
      return {
        ...state,
        fetchLabDetailLoading: false,
      };

    case constants.LAB_NOTIF_IS_EDIT:
      return {
        ...state,
        labNotificationIsEdit: action.data,
      };

    case constants.LAB_DETAIL_CLEANUP_FUNC:
      return {
        ...state,
        allLabs: [],
        createLabLoading: false,
        currentLabObj: {},
        labDetailsIsEdit: false,
        fetchLabsLoading: false,
        deleteLabLoading: false,
        labNotificationIsEdit: false,
        assignedUsers: [],
      };

    case constants.DELETE_STOCK_NOTIFICATION_RECIPIENT:
      return {
        ...state,
        deleteRecipientLoading: true,
      };

    case constants.DELETE_STOCK_NOTIFICATION_RECIPIENT_SUCCESS:
      return {
        ...state,
        deleteRecipientLoading: false,
      };

    case constants.DELETE_STOCK_NOTIFICATION_RECIPIENT_ERROR:
      return {
        ...state,
        deleteRecipientLoading: false,
      };

    case constants.FETCH_LAB_USERS:
      return {
        ...state,
        fetchLabUsersLoading: true,
      };
    case constants.FETCH_LAB_USERS_SUCCESS:
      return {
        ...state,
        fetchLabUsersLoading: false,
        assignedUsers: action.data,
      };
    case constants.FETCH_LAB_USERS_ERROR:
      return {
        ...state,
        fetchLabUsersLoading: false,
      };

    case constants.FETCH_LAB_USERS_MAP_SUCCESS:
      return {
        ...state,
        labUsersMap: {
          ...state.labUsersMap,
          ...action.data,
        },
      };

    case constants.FETCH_WAREHOUSES:
      return {
        ...state,
        fetchWarehousesLoading: true,
      };
    case constants.FETCH_WAREHOUSES_SUCCESS:
      return {
        ...state,
        warehouses: action.data,
        fetchWarehousesLoading: false,
      };
    case constants.FETCH_WAREHOUSES_ERROR:
      return {
        ...state,
        fetchWarehousesLoading: false,
      };

    default:
      return state;
  }
};

export default labsSetupReducer;
